import React, { useState } from "react";
import VideoCard from "./VideoCard";

function Videos() {
  const videoList = [
    {
      id: 1,
      title: "Zeroed Out - You Give Love (Cover)",
      src: "assets/videos/YouGiveLove.mp4",
      thumbnail: "assets/images/video_thumnails/yougivelove.png",
      description: "Live at river walk in Jenks, OK"
    },
    {
      id: 2,
      title: "Zeroed Out - Haunted",
      src: "assets/videos/Haunted.mp4",
      thumbnail: "assets/images/video_thumnails/haunted.png",
      description: "Live at river walk in Jenks, OK"
    }
  ];

  const [selectedVideo, setSelectedVideo] = useState(videoList[0]);

  return (
    <div>
      <h2 className="text-center text-2xl mb-4">Videos</h2>
      {/* HTML Video Element */}
      {selectedVideo && (
        <div className="video-container">
          <video
            key={selectedVideo.id} // Ensure re-rendering on selection change
            controls
            width="100%"
            className="max-w-full mx-auto"
          >
            <source src={selectedVideo.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}

      {/* Video Cards */}
      <div className="video-list mb-4">
        {videoList.map((video) => (
          <VideoCard
            key={video.id}
            video={video}
            handleSelectVideo={setSelectedVideo}
          />
        ))}
      </div>
    </div>
  );
}

export default Videos;
